import React from 'react'

const Loading = () => {
  return (
    <>Loading....</>
  )
}

export default Loading
